import {
  ColumnLayout,
  Container,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import { SETUP_TYPE, SUB_MODE, TS_PATHS } from 'features/plc/contracts/testStand.schema';
import { usePLCValue } from 'features/plc/providers/PLCProvider';
import PropTypes from 'prop-types';
import React from 'react';

import ChannelChart from './ChannelChart';
import ChannelGauge from './ChannelGauge';

export default function ChannelCard({ channelLabel, outputPaths }) {
  const setupType = usePLCValue(TS_PATHS.run.setupType) || SETUP_TYPE.CONTINUOUS_FLOW;
  const subMode = usePLCValue(TS_PATHS.run.subMode);
  const vesselPressure = usePLCValue(outputPaths.vesselPressure);
  const pipetteTipPressure = usePLCValue(outputPaths.pipetteTipPressure);
  const showVessel = setupType === SETUP_TYPE.CONTINUOUS_FLOW
    || (setupType === SETUP_TYPE.DISCRETE_FLOW && subMode === SUB_MODE.PRESSURE);

  return (
    <Container header={<Header variant="h3">{channelLabel}</Header>}>
      <SpaceBetween size="m">
        <ColumnLayout columns={showVessel ? 2 : 1}>
          {showVessel && (
            <ChannelGauge
              value={vesselPressure}
              min={0}
              max={5}
              unit="bar"
              label="Vessel pressure"
            />
          )}
          <ChannelGauge
            value={pipetteTipPressure}
            min={0}
            max={5}
            unit="bar"
            label="Pipette tip pressure"
          />
        </ColumnLayout>
        <ChannelChart
          vesselPressure={vesselPressure}
          pipetteTipPressure={pipetteTipPressure}
          showVessel={showVessel}
        />
      </SpaceBetween>
    </Container>
  );
}

ChannelCard.propTypes = {
  channelLabel: PropTypes.string.isRequired,
  outputPaths: PropTypes.shape({
    vesselPressure: PropTypes.shape({}).isRequired,
    pipetteTipPressure: PropTypes.shape({}).isRequired,
  }).isRequired,
};
